/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable eqeqeq */
import {
  createAsyncIterable,
  TransformStream,
  toPolyfillReadable,
  intoStandardStream,
  isToolCallAssistantMessage,
} from '../../utils'
import type { YiInput, YiGenerateOutput, YiStreamOutput } from './type'
import type {
  ModelReq,
  BaseChatModelInput,
  DoGenerateOutput,
  DoStreamOutput,
  BaseDoStreamOutputChunk,
  SimpleChatModel,
  ReqOptions,
} from '../../type'

function processInput(input: BaseChatModelInput): YiInput {
  const { messages, model, temperature, tools, top_p } = input

  return {
    ...input,
    messages,
    model,
    tools,
    top_p,
    temperature,
  }
}

export class YiSimpleModel implements SimpleChatModel {
  public subUrl = '01-ai/v1/chat/completions'

  constructor(private req: ModelReq, public baseUrl: string, subUrl?: string) {
    if (subUrl != null) {
      this.subUrl = subUrl
    }
  }

  private get url() {
    return `${this.baseUrl}/${this.subUrl}`
  }

  public async doGenerate(data: BaseChatModelInput, options?: ReqOptions): Promise<DoGenerateOutput> {
    const res = (await this.req({
      url: this.url,
      data: {
        ...processInput(data),
        stream: false,
      },
      stream: false,
      timeout: options?.timeout,
    })) as YiGenerateOutput
    return { ...res, rawResponse: res }
  }

  public async doStream(data: BaseChatModelInput, options?: ReqOptions): Promise<DoStreamOutput> {
    let isToolCall: null | boolean = null
    const _stream = await this.req({
      url: this.url,
      data: {
        ...processInput(data),
        stream: true,
      },
      stream: true,
      timeout: options?.timeout,
    })
    const stream = toPolyfillReadable(_stream) as typeof _stream

    const arkStream = intoStandardStream<YiStreamOutput>(stream)
    const streamWithRaw = arkStream.pipeThrough(new TransformStream<YiStreamOutput, BaseDoStreamOutputChunk & { rawResponse?: any }>({
      transform(chunk, controller) {
        // 非常奇葩
        if (!(chunk?.choices?.[0]?.delta?.content || chunk?.choices?.[0]?.delta?.tool_calls)) return

        const newChoices = chunk.choices.map((choice) => {
          const message = Object.assign(choice.delta, { role: 'assistant' }) as typeof choice.delta & {
            role: 'assistant'
          }
          if (isToolCall == null) isToolCall = isToolCallAssistantMessage(message)
          if (isToolCall) {
            return {
              ...choice,
              finish_reason: 'tool_calls' as const,
              delta: message,
            }
          }
          return { ...choice, delta: message }
        })
        const newChunk = { ...chunk, choices: newChoices }
        controller.enqueue({ ...newChunk, rawResponse: chunk })
      },
    }),)

    return createAsyncIterable(streamWithRaw)
  }
}
